import * as pako from "pako";
import { Base64 } from "js-base64";

export const debug = console.log;

export default function Respuesta({
  error = false,
  errorCod = 0,
  errorDsc = "",
  contenido = null,
  visible = false,
  origen = "",
}) {
  let obj = { error, errorDsc, errorCod, contenido, visible, origen };
  return obj;
}

export const establecerCookies = (nombre, valor) => {
  const fecha = new Date();
  fecha.setMonth(fecha.getMonth() + 1);
  const fechaExpiracion = fecha.toUTCString();
  document.cookie = `${nombre}=${valor}; expires=${fechaExpiracion}; path=/;`;
};

export const eliminarCookies = () => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }
};

export const actualizarCookie = (nombre, nuevoValor) => {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.startsWith(nombre + "=")) {
      document.cookie = cookie.substring(0, nombre.length + 1) + nuevoValor;
      break;
    }
  }
};

export const obtenerCookie = (nombre) => {
  const cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim(); // Elimina los espacios en blanco al principio y al final
    if (cookie.startsWith(nombre + "=")) {
      return cookie.substring(nombre.length + 1); // Retorna el valor de la cookie
    }
  }
  return ""; // Si no se encuentra la cookie, retorna null
};

export const validarLLamadoApi = ({ respuesta = null, endpoint, origen = "", validar = () => {} }) => {
  if (respuesta) {
    if (respuesta instanceof Error) {
      return Respuesta({
        error: true,
        errorCod: 1,
        errorDsc: respuesta.message + ` [${endpoint}]`,
        contenido: null,
        visible: true,
        origen,
      });
    } else if ([undefined, null].includes(respuesta.data)) {
      return Respuesta({
        error: false,
        errorCod: 2,
        errorDsc: "Peticion Cancelada",
        contenido: null,
        visible: true,
        origen,
      });
    } else if ("SMListaErrores" in respuesta.data && respuesta.data.SMListaErrores.length > 0) {
      //debug
      respuesta.data.SMListaErrores.push({
        descripcionError: ` [${endpoint}]`,
      });
      // console.log(respuesta.data.SMListaErrores)
      let hayError = false;
      let tituloError = "";
      for (let temp of respuesta.data.SMListaErrores) {
        // console.log(temp)
        switch (temp?.tipoError) {
          case "E":
            hayError = true;
            tituloError = "Errores de Servicio";
            break;
          case "W":
            hayError = false;
            tituloError = "Advertencia";
            break;
        }
      }
      console.log(hayError);
      return Respuesta({
        error: hayError,
        errorCod: 3,
        errorDsc: tituloError,
        contenido: respuesta.data,
        visible: true,
        origen,
      });
    } else {
      return Respuesta({ contenido: respuesta.data, origen });
    }
  } else {
    return Respuesta({
      error: true,
      errorCod: 4,
      errorDsc: `ninguna respuesta [${endpoint}]`,
      contenido: null,
      visible: true,
      origen,
    });
  }
};

export const AlertaMensajeError = (respuesta) => {
  alert(respuesta.SMListaErrores?.reduce((acumulador, actual) => acumulador + actual.descripcionError, "\n"));
};

export function f_logicaNavegacion(programa, descripcion, opcionMenu, eopcionMenu, enavegacion) {
  if (programa == null) {
    eopcionMenu(null);
    enavegacion([]);
    return;
  }

  if (programa && opcionMenu !== programa) {
    eopcionMenu(programa);
    enavegacion((prev) => {
      const historialFiltrado = prev.filter((item) => item.programa !== programa);
      const nuevoHistorial = [...historialFiltrado, { programa, descripcion }];
      return nuevoHistorial.slice(-5);
    });
  }
}

export const capitalizarPalabras = (texto = "") => {
  // 1. Verificamos si texto es null, undefined o no es un string
  if (!texto || typeof texto !== "string") {
    return ""; // O puedes devolver el valor original si prefieres
  }
  return texto
    .trim()
    .split(/\s+/)
    .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1).toLowerCase())
    .join(" ");
};

export const estilosObjetoVariablesCSS = (objeto) => {
  if (objeto) {
    const cssVars = Object.fromEntries(
      Object.entries(objeto).map(([key, value]) => {
        const varName = key.startsWith("--") ? key : `--${key}`;
        return [varName, value];
      }),
    );
    //console.log(cssVars)
    return cssVars;
  }
  return {};
};

export const limpiarTexto = (texto) => {
  return texto
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ñ/g, "n")
    .replace(/ü/g, "u");
};

export const coincidenciaTotal = (cad1, cad2) => {
  return limpiarTexto(cad1) === limpiarTexto(cad2);
};

export const coincidenciaParcial = (busqueda, textoCompleto) => {
  return limpiarTexto(textoCompleto).includes(limpiarTexto(busqueda));
};

export const asignar = (fEstablecer, props = {}, sincronizar = false, origen = "", endpoint = "") => {
  // console.log("======================================")
  // console.log("fEstablecer",fEstablecer);
  // console.log("props",props);
  // console.log("sincronizar",sincronizar);
  // console.log("origen",origen);
  // console.log("endpoint",endpoint);
  if (fEstablecer instanceof Function) {
    if (sincronizar) {
      //console.log("sincronizar", endpoint);
      fEstablecer((prev) => {
        if (prev?.visible && prev?.error && origen == prev?.origen) return { ...prev, visible: true };
        else
          return {
            ...prev,
            ...props,
          };
      });
    } else {
      //console.log("no sincroniza", endpoint);
      fEstablecer((prev) => ({
        ...prev,
        ...props,
      }));
    }
  } else if (fEstablecer instanceof Set) {
  } else if (typeof fEstablecer === "object" && fEstablecer !== null) {
    return { ...fEstablecer, ...props };
  } else {
  }
};

export const evaluarOperador = (operando1, operador, operando2) => {
  switch (operador) {
    case "==":
      return operando1 == operando2;
    case "===":
      return operando1 === operando2;
    case "!=":
      return operando1 != operando2;
    case "!==":
      return operando1 !== operando2;
    case ">":
      return operando1 > operando2;
    case ">=":
      return operando1 >= operando2;
    case "<":
      return operando1 < operando2;
    case "<=":
      return operando1 <= operando2;
    case "includes":
      return String(operando1).includes(operando2);
    default:
      return false;
  }
};

export const aplicarConector = (operando1, conector, operando2) => {
  const op = conector ? conector.toLowerCase() : "and";
  switch (op) {
    case "and":
      return operando1 && operando2;
    case "or":
      return operando1 || operando2;
    case "xor":
      return Boolean(operando1 ^ operando2);
    case "not":
      return operando1 && !operando2; // AND NOT
    default:
      return operando1 && operando2;
  }
};

export const evaluarReglas = (reglas, datos) => {
  if (!reglas || reglas.length === 0) return false;
  /* const reglas = [
  { campo: "¿Habilitado?", criterio: 'S', operador: "==", conector: "and" },
  { campo: "otro", criterio: 'S', operador: "==", conector: "or" }
  ]; 
  
  const datos = { "¿Habilitado?": 'S', "otro": 3 };

  */
  const primeraRegla = reglas[0];
  let acumulado = evaluarOperador(datos[primeraRegla.campo], primeraRegla.operador, primeraRegla.criterio);

  // 2. Iteramos desde la segunda regla usando el conector de la regla previa
  for (let i = 1; i < reglas.length; i++) {
    const reglaAnterior = reglas[i - 1];
    const reglaActual = reglas[i];

    const resultadoActual = evaluarOperador(datos[reglaActual.campo], reglaActual.operador, reglaActual.criterio);

    // Conectamos el acumulado previo con el resultado de la regla actual
    acumulado = aplicarConector(acumulado, reglaAnterior.conector, resultadoActual);
  }

  return Boolean(acumulado);
};

export const evaluarReglasDeEstados = (reglasDeEstados, datos) => {
  if (!reglasDeEstados || !Array.isArray(reglasDeEstados)) return [];

  return reglasDeEstados.map((estado) => ({
    tipo: estado.tipo,
    resultado: evaluarReglas(estado.reglas, datos),
  }));
};

export const concatenarValoresConArreglo = ({
  arregloClaves = [],
  objeto = {},
  clave = "",
  union = " ",
  prefijo = "",
}) => {
  let resultado = "";
  if (clave !== "") {
    resultado = prefijo + "" + arregloClaves.map((ac) => ac[clave]).join(union);
  } else {
    resultado = prefijo + "" + arregloClaves.map((ac) => objeto?.[ac]).join(union);
  }
  return resultado;
};

export const fechaActual = ({ formato = "yyyy-mm-dd" } = {}) => {
  const f = new Date();

  const d = String(f.getDate()).padStart(2, "0");
  const m = String(f.getMonth() + 1).padStart(2, "0");
  const yyyy = f.getFullYear();
  const yy = String(yyyy).slice(-2);

  return formato.toLowerCase().replace("yyyy", yyyy).replace("yy", yy).replace("mm", m).replace("dd", d);
};

export const horaActual = ({ formato = "hh:mm:ss" } = {}) => {
  const f = new Date();

  const hh = String(f.getHours()).padStart(2, "0");
  const mm = String(f.getMinutes()).padStart(2, "0");
  const ss = String(f.getSeconds()).padStart(2, "0");

  return formato
    .toLowerCase()
    .replace("hh", hh)
    .replace("mm", mm)
    .replace("ss", ss);
};



// export const formatearFecha = ({ valor, formato = "yyyy-mm-dd" } = {}) => {
//   // 1. Si viene vacío, retornamos null
//   if (valor === "" || valor === null || valor === undefined) return null;

//   // 2. Convertimos el valor a objeto Date (soporta "yyyy-mm-dd", ISO string, timestamp o Date)
//   // Nota: Para evitar desfases de zona horaria al parsear "YYYY-MM-DD", ajustamos si es necesario:
//   const esSoloFecha = typeof valor === "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor);
//   const f = esSoloFecha ? new Date(`${valor}T00:00:00`) : new Date(valor);

//   // 3. Si la fecha parseada no es válida (ej. "texto_raro"), retornamos null
//   if (isNaN(f.getTime())) return null;

//   const d = String(f.getDate()).padStart(2, "0");
//   const m = String(f.getMonth() + 1).padStart(2, "0");
//   const yyyy = f.getFullYear();
//   const yy = String(yyyy).slice(-2);

//   return formato
//     .toLowerCase()
//     .replace("yyyy", yyyy)
//     .replace("yy", yy)
//     .replace("mm", m)
//     .replace("dd", d);
// };
export const formatearFecha = ({
  valor,
  formato = "yyyy-mm-dd",
  incluirHora = false,
  formatoHora = 24,
  ajustarZonaHoraria = false,
  zonaHoraria = "America/Lima",
} = {}) => {
  // 1. Si viene vacío
  if (valor === "" || valor === null || valor === undefined) {
    return null;
  }

  // ============================================================
  // CASO 1: SOLO FECHA
  // ============================================================

  const esSoloFecha = typeof valor === "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor);

  if (esSoloFecha) {
    const [, yyyy, m, d] = valor.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    return formato.replace(/yyyy/gi, yyyy).replace(/yy/g, yyyy.slice(-2)).replace(/mm/g, m).replace(/dd/g, d);
  }

  // ============================================================
  // CASO 2: NO AJUSTAR ZONA HORARIA
  //
  // IMPORTANTE:
  // No usamos new Date() aquí.
  //
  // Tomamos literalmente los valores que vienen en el string.
  //
  // 2025-03-07T09:27:10Z
  //               ^^
  //               se conserva como 09
  // ============================================================

  if (!ajustarZonaHoraria) {
    const match = String(valor).match(
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/,
    );

    if (!match) {
      // Si no tiene el formato esperado, intentamos Date
      const f = new Date(valor);

      if (isNaN(f.getTime())) {
        return null;
      }

      const d = String(f.getDate()).padStart(2, "0");
      const m = String(f.getMonth() + 1).padStart(2, "0");
      const yyyy = f.getFullYear();
      const yy = String(yyyy).slice(-2);

      return formato.replace(/yyyy/gi, yyyy).replace(/yy/g, yy).replace(/mm/g, m).replace(/dd/g, d);
    }

    const [, yyyy, m, d, horaOriginal, minutos, segundos] = match;

    let resultado = formato.replace(/yyyy/gi, yyyy).replace(/yy/g, yyyy.slice(-2)).replace(/mm/g, m).replace(/dd/g, d);

    // Si no queremos hora
    if (!incluirHora) {
      return resultado;
    }

    let horas = parseInt(horaOriginal, 10);
    let periodo = "";

    if (formatoHora === 12) {
      periodo = horas >= 12 ? "pm" : "am";
      horas = horas % 12 || 12;
    }

    const hora = String(horas).padStart(2, "0");

    return resultado
      .replace(/HH/g, hora)
      .replace(/hh/g, hora)
      .replace(/MM/g, minutos)
      .replace(/ss/g, segundos)
      .replace(/a/g, periodo);
  }

  // ============================================================
  // CASO 3: AJUSTAR ZONA HORARIA
  //
  // Aquí SÍ usamos Date porque queremos interpretar el valor
  // y convertirlo a la zona indicada.
  // ============================================================

  const f = new Date(valor);

  if (isNaN(f.getTime())) {
    return null;
  }

  const partes = new Intl.DateTimeFormat("en-US", {
    timeZone: zonaHoraria,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: formatoHora === 12,
  }).formatToParts(f);

  const obtener = (tipo) => partes.find((parte) => parte.type === tipo)?.value ?? "";

  const yyyy = obtener("year");
  const m = obtener("month");
  const d = obtener("day");

  let resultado = formato.replace(/yyyy/gi, yyyy).replace(/yy/g, yyyy.slice(-2)).replace(/mm/g, m).replace(/dd/g, d);

  // Si no queremos hora
  if (!incluirHora) {
    return resultado;
  }

  const hora = obtener("hour");
  const minutos = obtener("minute");
  const segundos = obtener("second");
  const periodo = obtener("dayPeriod");

  return resultado
    .replace(/HH/g, hora)
    .replace(/hh/g, hora)
    .replace(/MM/g, minutos)
    .replace(/ss/g, segundos)
    .replace(/a/g, periodo);
};


export const formatearValor = ({
  valor,
  tipo,
  moneda = "USD",
  precision,
  longitud = 5,
  caracter = "0",
  posicion = "inicio",

  // Parámetros para fecha y hora
  formato = "yyyy-mm-dd",
  incluirHora = false,
  formatoHora = 24,
  ajustarZonaHoraria = false,
  zonaHoraria = "America/Lima",
} = {}) => {
  // 1. Si no hay valor o no se especifica tipo
  if (valor === null || valor === undefined || !tipo) {
    return valor;
  }

  const MONEDAS = {
    USD: { code: "USD", locale: "en-US" },
    DOLAR: { code: "USD", locale: "en-US" },
    PEN: { code: "PEN", locale: "es-PE" },
    SOLES: { code: "PEN", locale: "es-PE" },
    EUR: { code: "EUR", locale: "de-DE" },
    EURO: { code: "EUR", locale: "de-DE" },
    MXN: { code: "MXN", locale: "es-MX" },
    PESOS: { code: "MXN", locale: "es-MX" },
    ARS: { code: "ARS", locale: "es-AR" },
    CLP: { code: "CLP", locale: "es-CL" },
  };

  switch (tipo.toLowerCase()) {
    // FORMATO MONEDA
    case "moneda": {
      const num = Number(valor);

      // Si no es un número válido, se conserva el valor
      if (isNaN(num)) return valor;

      const claveMoneda = moneda.toUpperCase();
      const config = MONEDAS[claveMoneda] || {
        code: claveMoneda,
        locale: "es-ES",
      };

      const dec = precision ?? 2;

      return new Intl.NumberFormat(config.locale, {
        style: "currency",
        currency: config.code,
        minimumFractionDigits: dec,
        maximumFractionDigits: dec,
      }).format(num);
    }

    // CAPITALIZAR TEXTO
    case "capitalizar": {
      if (typeof valor === "number") return valor;

      const texto = String(valor).trim();
      if (!texto) return valor;

      return texto
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
    }

    // RELLENO (PADDING)
    case "relleno": {
      const texto = String(valor);

      return posicion === "fin"
        ? texto.padEnd(longitud, caracter)
        : texto.padStart(longitud, caracter);
    }

    // NÚMERO FIJO
    case "numero": {
      const num = Number(valor);

      if (isNaN(num)) return valor;

      return num.toFixed(precision ?? 2);
    }

    // FORMATO FECHA, HORA O FECHA Y HORA
    case "fecha": {
      const resultado = formatearFecha({
        valor,
        formato,
        incluirHora,
        formatoHora,
        ajustarZonaHoraria,
        zonaHoraria,
      });

      // Mantener el valor original si no se pudo formatear
      return resultado ?? valor;
    }

    default:
      return valor;
  }
};


export const obtenerHoraActual = () => {
  const ahora = new Date();
  const horas = ahora.getHours().toString().padStart(2, "0");
  const minutos = ahora.getMinutes().toString().padStart(2, "0");
  const segundos = ahora.getSeconds().toString().padStart(2, "0");
  return `${horas}:${minutos}:${segundos}`;
};

export const limpiarAsignacion = (fEstablecer, ...propiedades) => {
  if (typeof fEstablecer !== "function" || propiedades.length === 0) return;

  const listaProps = propiedades.flat();

  fEstablecer((prev) => {
    const actualizaciones = {};

    listaProps.forEach((prop) => {
      if (prop in prev) {
        const val = prev[prop];

        if (typeof val === "function") {
          actualizaciones[prop] = () => {};
        } else if (Array.isArray(val)) {
          actualizaciones[prop] = [];
        } else if (val !== null && typeof val === "object") {
          actualizaciones[prop] = {};
        } else {
          switch (typeof val) {
            case "string":
              actualizaciones[prop] = "";
              break;
            case "number":
              actualizaciones[prop] = 0;
              break;
            case "boolean":
              actualizaciones[prop] = false;
              break;
            default:
              actualizaciones[prop] = null;
          }
        }
      }
    });

    return {
      ...prev,
      ...actualizaciones,
    };
  });
};

export const capitalizar_palabra = (texto) => {
  let palabras = texto.toLowerCase().split(" ");
  let capitalizarPalabras = palabras.map((palabra) => {
    return palabra.charAt(0).toUpperCase() + palabra.slice(1);
  });
  return capitalizarPalabras.join(" ");
};

export const descomprimirDatos = (base64str) => {
  const binaryString = Base64.toUint8Array(base64str); // base64 → bytes
  const descomprimido = pako.ungzip(binaryString, { to: "string" }); // gzip → string
  return JSON.parse(descomprimido); // JSON → objeto
};

export const descargarExcelBase64 = ({ base64, nombreArchivo = 'reporte.xlsx' }) => {
  try {
    // 1. Limpiar el string base64 por si incluye el prefijo (ej: "data:application/vnd...;base64,")
    const base64Limpio = base64.includes(',') ? base64.split(',')[1] : base64;

    // 2. Decodificar el base64 a caracteres binarios
    const byteCharacters = atob(base64Limpio);
    const byteNumbers = new Array(byteCharacters.length);
    
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    
    const byteArray = new Uint8Array(byteNumbers);

    // 3. Crear un Blob con el tipo MIME correspondiente a un archivo Excel (.xlsx)
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // 4. Generar una URL temporal para el Blob
    const url = window.URL.createObjectURL(blob);

    // 5. Crear un elemento <a> invisible para simular el clic de descarga
    const link = document.createElement('a');
    link.href = url;
    link.download = nombreArchivo;
    
    document.body.appendChild(link);
    link.click();

    // 6. Limpiar el DOM y revocar la URL para liberar memoria
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
  } catch (error) {
    console.error('Error al intentar descargar el archivo Excel:', error);
  }
};